import { render } from "./Dropdown5.vue?vue&type=template&id=8f59aa34&ts=true"
import script from "./Dropdown5.vue?vue&type=script&lang=ts"
export * from "./Dropdown5.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__